import React, { HTMLAttributes, useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';

import ButtonComponent from '../../../Button';
import Close from '../../../ButtonCancel';
import FinishCall from '../FinishCall';
import Select from '../../../Select';
import InputDate from '../../../InputDatePicker';
import API from '../../../../services/api';

import {
  formatTelephone,
  formatTelephoneReverse,
} from '../../../../services/utils/formatTELandCEP';
import { Content, Input } from './styles';
import { navigationUrl } from '../../../../store/analytic/actions';
import { toast } from 'react-toastify';
import Toast from '../../../Toast';
import Loading from '../../../Loading';

interface IDetails {
  title: string;
  subtitle: string;
  detail: string;
  datehour: string;
}
interface Props extends HTMLAttributes<HTMLElement> {
  handlerClose: () => void;
  onClick: () => void;
  changeTitle: () => void;
  value: string;
  textbtn: string;
  text2btn: string;
  type: 'ReceberLigacao' | '';
  details: IDetails;
  sign: boolean;
  maxLength?: number;
  verification: string;
}

const FillPhone: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const [nextPage, setNextPage] = useState(false);
  const { userConfirmedData } = useSelector((state: ApplicationState) => {
    return {
      userConfirmedData: state.auth.userConfirmedData,
    };
  });

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: props.verification
          ? '/preencheReceberLigacaoAgora'
          : '/preencheAgendarLigacao',
      })
    );
  }, [dispatch, props.verification]);

  const [date, setDate] = useState(new Date());
  const [selectedHour, setSelectedHour] = useState('');
  const [telephone, setTelephone] = useState(
    `${userConfirmedData?.ddd_tel ? userConfirmedData?.ddd_tel?.trim() : ' '}${
      userConfirmedData?.telephone
    }`
  );
  const [loading, setLoading] = useState(false);

  const handlePhoneValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTelephone(formatTelephoneReverse(e.target.value));
  };

  const tel = formatTelephoneReverse(telephone);

  const isFormValid = useMemo(() => {
    const validPhoneLength = tel.length === 11 || tel.length === 10;
    if (props.type === 'ReceberLigacao') return validPhoneLength;
    return validPhoneLength && selectedHour;
  }, [selectedHour, tel, props.type]);

  const nextStep = async () => {
    if (isFormValid) {
      try {
        setLoading(true);
        let dateHour: moment.Moment;
        if (props.type === 'ReceberLigacao') {
          dateHour = moment().add(1, 'minute');
          setSelectedHour(dateHour.format('HH:mm'));
        } else {
          dateHour = moment(date);
        }

        await API.setCall({
          dataHora: dateHour.format(
            `YYYY-MM-DD[T]${selectedHour || 'HH:mm'}:ss`
          ),
          ddd_tel: tel.slice(0, 2),
          telephone: tel.slice(2),
        }, props.value);
        props.changeTitle();
        setNextPage(!nextPage);
      } catch (e) {
        toast.error(<Toast title='Erro' description={e.message} />);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDateValue = (e: any) => {
    setDate(e);
  };

  const handleList = (e: any) => {
    setSelectedHour(e.target.value);
  };

  return (
    <>
      {!nextPage ? (
        <div>
          <Content type={props.type}>
            <div className='title_receivecall'>
              <span>
                Preencha os dados abaixo para receber uma ligação agora:
              </span>
              <div className='subtitle_receivecall'>
                <span>Seu CPF:</span>
                <div className='default'>
                  <Input
                    value={props.value}
                    style={{ background: '#DFE4EF' }}
                    readOnly={true}
                  />
                </div>
              </div>
              <div className='subtitle_receivecall'>
                <span>Seu Telefone:</span>
                <div className='default'>
                  {props.sign ? (
                    <Input
                      value={formatTelephone(telephone) || ''}
                      onChange={handlePhoneValue}
                      placeholder='Preencha seu Telefone'
                      maxLength={15}
                    />
                  ) : (
                    <Input
                      value={formatTelephone(tel)}
                      onChange={handlePhoneValue}
                      placeholder='Preencha seu Telefone'
                      maxLength={15}
                    />
                  )}
                </div>
              </div>
              <div className='datehour_receivecall'>
                <div className='date_receivecall'>
                  <span>Data:</span>
                  <InputDate value={date} Onchange={handleDateValue} />
                </div>
                <div className='hour_receivecall'>
                  <span>Hora:</span>
                  <Select
                    date={date}
                    name='list'
                    value={selectedHour}
                    onChange={handleList}
                  />
                </div>
              </div>
              <div className='btns_receivecall'>
                {nextPage ? (
                  <FinishCall
                    handlerClose={props.handlerClose}
                    details={props.details}
                    verification={props.verification}
                  />
                ) : (
                  <ButtonComponent
                    height={60}
                    onClick={nextStep}
                    color={'primary'}
                    fontSize={'16'}
                    borderRadios={'16'}
                    disabled={!isFormValid}
                  >
                    {loading ? (
                      <Loading />
                    ) : (
                      <p>
                        {props.textbtn}
                        <span>{props.text2btn}</span>
                      </p>
                    )}
                  </ButtonComponent>
                )}
                {!props.sign && <Close onClick={props.onClick}>VOLTAR</Close>}
              </div>
            </div>
          </Content>
        </div>
      ) : (
        <FinishCall
          verification={props.verification}
          handlerClose={props.handlerClose}
          details={{
            ...props.details,
            datehour: moment(date).format(`DD/MM/YYYY [às] ${selectedHour}`),
          }}
        />
      )}
    </>
  );
};

export default FillPhone;
